import {
  VariableUpdateType,
  CommonVariableDefinitionType,
} from 'pages/AutomationEngine/types/automation';

import * as StaticVariable from 'pages/AutomationEngine/dialogs/VariableWizard/variable-types/StaticVariable';
import * as FieldValueVariable from 'pages/AutomationEngine/dialogs/VariableWizard/variable-types/FieldValue';
import * as AutomationVariable from './AutomationVariable';

import { VariableSourceComponent } from 'pages/AutomationEngine/dialogs/VariableWizard/types';

export const Lookup: Record<VariableUpdateType, VariableSourceComponent> = {
  ['static']: StaticVariable,
  ['field_value']: FieldValueVariable,
  ['variable']: AutomationVariable,
};

export const isVariableUpdateType = (
  type: CommonVariableDefinitionType
): type is VariableUpdateType => Object.hasOwn(Lookup, type);

export const getSourceLookUp = (type: CommonVariableDefinitionType) =>
  isVariableUpdateType(type) ? Lookup[type] : undefined;

export default Lookup;
